(function() {
  'use strict';

  var registry = window.PooleaseSectionScripts = window.PooleaseSectionScripts || {};

  function initSection(section) {
    if (!section || section.dataset.accessoriesReady === 'true') return;
    var toggle = section.querySelector('[data-accessories-toggle]');
    var overflow = section.querySelector('[data-accessories-overflow]');
    if (!toggle || !overflow) return;

    section.dataset.accessoriesReady = 'true';
    toggle.addEventListener('click', function() {
      var isOpen = toggle.getAttribute('aria-expanded') === 'true';
      var total = toggle.getAttribute('data-total') || '0';
      toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      toggle.classList.toggle('is-open', !isOpen);
      overflow.classList.toggle('is-open', !isOpen);
      overflow.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
      toggle.querySelector('[data-toggle-label]').textContent =
        isOpen ? 'Show all ' + total + ' accessories' : 'Show less';
    });
  }

  function initAll(root) {
    var scope = root || document;
    if (scope.matches && scope.matches('.product-accessories')) initSection(scope);
    var sections = scope.querySelectorAll ? scope.querySelectorAll('.product-accessories') : [];
    for (var i = 0; i < sections.length; i++) initSection(sections[i]);
  }

  if (registry.productAccessories) {
    registry.productAccessories(document);
    return;
  }
  registry.productAccessories = initAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function(event) { initAll(event.target); });
})();
